import React, { useEffect, useState } from 'react'
import { setActiveTaskList, setTasks } from '../../redux/slices/AiTasks';
import { useDispatch, useSelector } from 'react-redux';
import { XMLParser } from 'fast-xml-parser';
import { saveTaskList } from '../action/chatGPT';
import { TasksMenuIcon } from '../LandingHeader/Feedback/icons/Icons';
import ReactMarkdown from 'react-markdown'
import rehypeMathjax from 'rehype-mathjax';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter'
import {dark} from 'react-syntax-highlighter/dist/esm/styles/prism'
import rehypeKatex from 'rehype-katex'
import 'katex/dist/katex.min.css' // `rehype-katex` does not import the CSS for you

const CompletionContent = ({content, id}) => {
    const dispatch = useDispatch();
    const taskList = useSelector(state =>  state.aiAssistant.taskList);
    const [tagMatch, setTagMatch] = useState(null);
    const [endTagMatch, setEndTagMatch] = useState(null);
    const parser = new XMLParser();

    useEffect(() => {
        //console.log('content', content)
        const jsonString = String(content).replace(/\n$/, '');
        const tagMatch = jsonString.match(/<TasksList\s{1,}uniqueId=[\'\"](.*)[\'\"]/i);
        const endTagMatch = jsonString.match(/<\/TasksList>/);
        //console.log('tagMatchtagMatch', tagMatch, taskList)
        if(tagMatch?.[1]){
            if(taskList?.[tagMatch[1]]){
                dispatch(setTasks({tasks: Array.isArray(taskList[tagMatch[1]]) ? taskList[tagMatch[1]] : [taskList[tagMatch[1]]], activeTaskList: tagMatch[1]}));
            }else{
                dispatch(setActiveTaskList(tagMatch[1]));
                try{
                    const jsonObj = parser.parse(jsonString);
                    if(jsonObj?.TasksList?.task){
                        const data = {tasks: Array.isArray(jsonObj?.TasksList?.task) ? jsonObj?.TasksList?.task : [jsonObj?.TasksList?.task], activeTaskList: tagMatch[1]}
                        dispatch(setTasks(data));
                        // Save the active task list
                        if(endTagMatch){
                            saveTaskList({...data, id});
                        }
                    }
                }catch(e){
                    //console.log('Invalid data', jsonString)
                }
            }
        }
        setTagMatch(tagMatch);
        setEndTagMatch(endTagMatch);
    }, [content, taskList])

    return tagMatch?.[1] ? <div className='flex items-center justify-center gap-[5px]' style={{padding: '0 20px', fontSize: '18px', fontWeight: 700, color: '#000', background: 'rgb(235 235 235)', borderRadius: 10, border: '1px solid grey'}}>
        {
            endTagMatch
            ?
            <>
                <TasksMenuIcon />
                <span className='cursor-pointer accent-text-color' style={{padding: '20px 0 20px 20px', borderLeft: '1px solid grey'}} onClick={e => dispatch(setActiveTaskList(tagMatch[1]))}>Your tasks list</span>
            </>
            :
            <>
                <span style={{borderTopColor: 'var(--accent-color)'}} className='spinner' />
                <span className='accent-text-color' style={{padding: '20px 0 20px 20px', borderLeft: '1px solid grey'}}>Creating your tasks list...</span>
            </>
        }
    </div>
    :
    <ReactMarkdown 
        children={content} 
        remarkPlugins={[remarkGfm, remarkMath]} 
        rehypePlugins={[rehypeMathjax, rehypeKatex]}
        components={{
            code({node, inline, className, children, ...props}) {
                const match = /language-(\w+)/.exec(className || '');
                const jsonString = String(children).replace(/\n$/, '');
                
                return !inline ? (
                    <SyntaxHighlighter
                    {...props}
                    children={jsonString}
                    style={dark}
                    language={(match && match[1]) || ''}
                    />
                ) : (
                    <pre><code {...props} className={className}>
                    {children}
                    </code></pre>
                )
            }
        }} 
    /> 
}

export default CompletionContent